import { render, staticRenderFns } from "./SettingCompetency.vue?vue&type=template&id=5a951024&scoped=true"
import script from "./SettingCompetency.vue?vue&type=script&lang=js"
export * from "./SettingCompetency.vue?vue&type=script&lang=js"
import style0 from "./SettingCompetency.vue?vue&type=style&index=0&id=5a951024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a951024",
  null
  
)

export default component.exports